import Axios from "axios";
import router from "@/router";

const DEFAULT_ERROR_MESSAGE =
  "Не удалось выполнить запрос. Проверьте подключение и попробуйте снова.";

const normalizeErrorDetail = (error) => {
  const responseData = error?.response?.data;

  if (responseData && typeof responseData === "object") {
    return responseData.detail || responseData;
  }

  if (typeof responseData === "string" && responseData.trim()) {
    return responseData;
  }

  if (typeof error?.message === "string" && error.message.trim()) {
    return error.message;
  }

  return DEFAULT_ERROR_MESSAGE;
};

const normalizeErrorResponse = (error) => ({
  data: null,
  detail: normalizeErrorDetail(error),
});

class ApiConnector {
  connector;
  connectorFormData;
  constructor() {
    this.connector = Axios.create({
      baseURL: process.env.VUE_APP_API_URL,
    });
    this.connectorFormData = Axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    this.connector.interceptors.request.use(
      (config) => {
        const token = router.currentRoute.value.params.token;
        if (token) {
          config.params = {
            ...config.params,
            token: token,
          };
        }
        return config;
      },
      (error) => Promise.reject(error),
    );

    this.connectorFormData.interceptors.request.use(
      (config) => {
        const token = router.currentRoute.value.params.token;
        if (token) {
          config.params = {
            ...config.params,
            token: token,
          };
        }
        return config;
      },
      (error) => Promise.reject(error),
    );

    this.connector.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        return normalizeErrorResponse(error);
      },
    );
    this.connectorFormData.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        return normalizeErrorResponse(error);
      },
    );
  }
}

export default new ApiConnector();
